/**
 * Extract customer ID from Shopify analytics object
 */
export function getCustomerId(): string | undefined {
  // Shopify analytics object (window.__st)
  const st = (window as any).__st;
  if (st && st.cid) {
    return String(st.cid);
  }
  return undefined;
}

